import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { useEffect, useState } from 'react';
// @mui
import {
  Card,
  Stack,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TablePagination,
  Grid,
  Box,
  Button,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
// components
import Scrollbar from '../components/scrollbar';
// sections
import GalleryCategoryCard from '../components/card/GalleryCategoryCard';
import { getGalleryFolderMethod } from '../redux/slice/gallerySlice';

function descendingComparator(a, b, orderBy) {
  // Handle null values
  if (!a || !b) {
    return a ? -1 : b ? 1 : 0; // Move null values to the end
  }

  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user?.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function GalleyCategoryPage() {
  const dispatch = useDispatch();

  const data = useSelector((state) => state.gallery);
  const [isGallary, setIsGallary] = useState('All');

  useEffect(() => {
    dispatch(getGalleryFolderMethod(isGallary));
  }, [dispatch, isGallary]);

  const [page, setPage] = useState(0);

  const [order] = useState('asc');

  const [orderBy] = useState('name');

  const [filterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(8);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const filteredUsers = applySortFilter(data.data !== null ? data.data : [], getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;
  return (
    <>
      <Helmet>
        <title> Galley Folder | PakPrint Wishes </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Galley Category Wise Folder ({isGallary})
          </Typography>
          <Box display="flex" gap={2}>
            <Button variant="contained" onClick={() => setIsGallary('All')}>
              All Gallery
            </Button>
            <Button variant="contained" onClick={() => setIsGallary('Admin')}>
              Admin Gallery
            </Button>
            <Button variant="contained" onClick={() => setIsGallary('Vendor')}>
              Vendor Gallery
            </Button>
          </Box>
        </Stack>
        <Card>
          <Scrollbar>
            <Grid container spacing={2} p={2}>
              {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={row?._id}>
                  <GalleryCategoryCard row={row} />
                </Grid>
              ))}
            </Grid>
            {isNotFound && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <Paper
                      sx={{
                        textAlign: 'center',
                      }}
                    >
                      <Typography variant="h6" paragraph>
                        Not found
                      </Typography>

                      <Typography variant="body2">
                        No results found for &nbsp;
                        <strong>&quot;{filterName}&quot;</strong>.
                        <br /> Try checking for typos or using complete words.
                      </Typography>
                    </Paper>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[8, 16, 24, 48, 96]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </>
  );
}
